import {CentralContent} from "../components/central-content/CentralContent";
import {WakeletHeader} from "../components/wakelet-header/WakeletHeader";
import {translateKey} from "../components/language/translate";
import {SwitchAccount} from "../components/switch-account/SwitchAccount";
import {Page} from "./Page";

export const SwitchAccountPage = () => {
  return <Page>
    <CentralContent>
      <div className="flex flex-col flex-grow w-full switch">
        <WakeletHeader message={translateKey("account:switchAccount.title")}/>
        <SwitchAccount/>
      </div>
    </CentralContent>
  </Page>;
};